import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'

Vue.config.productionTip = false


axios.defaults.withCredentials = true;

Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.axios.interceptors.request.use(config => {
  if (config.method.toUpperCase() === 'POST' || config.method.toUpperCase() === 'PATCH' || config.method.toUpperCase() === 'PUT')
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
  return config;
});

Vue.axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    const msg = {
      event: 'notAuthorized',
      data: {}
    };
    parent.postMessage(msg, '*');
  }
  return null;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
